import Radio from './src/radio.vue'

export default Radio
